import * as React from "react";
import { useId } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBell = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		viewBox: "0 0 20 20",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: /* @__PURE__ */ _jsx("path", {
			d: "M12.3271 15.43 C12.3271 16.7152 11.2852 17.7571 10 17.7571 C8.7148 17.7571 7.6729 16.7152 7.6729 15.43 M11.3936 5.5309 C11.7314 5.1819 11.9392 4.7063 11.9392 4.1822 C11.9392 3.1112 11.0711 2.243 10.0001 2.243 C8.929 2.243 8.0608 3.1112 8.0608 4.1822 C8.0608 4.7063 8.2686 5.1819 8.6065 5.5309 M14.6542 9.3795 C14.6542 8.3097 14.1639 7.2837 13.2911 6.5272 C12.4182 5.7708 11.2344 5.3458 10 5.3458 C8.7656 5.3458 7.5818 5.7708 6.709 6.5272 C5.8361 7.2837 5.3458 8.3097 5.3458 9.3795 C5.3458 11.1495 4.9068 12.4439 4.3591 13.3702 C3.7349 14.4259 3.4228 14.9538 3.4351 15.0799 C3.4492 15.2241 3.4752 15.2696 3.5922 15.3552 C3.6944 15.43 4.2082 15.4299 5.2358 15.4299 L14.7642 15.43 C15.7918 15.43 16.3056 15.4299 16.4079 15.3552 C16.5248 15.2696 16.5508 15.2241 16.5649 15.0799 C16.5772 14.9538 16.2651 14.4259 15.6409 13.3702 C15.0932 12.444 14.6542 11.1495 14.6542 9.3795",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	});
};
export default SvgBell;
